export default __webpack_public_path__ + "static/media/search.8822e7ad.png";